<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Withdrawal Same Name') }}</h3>
                <span class="fz-16 fw-400">{{ $t("Fill out the form to initiate a withdrawal") }}</span>
            </div>

            <step-container :current_step="3" :step_list="stepList"></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">

            <b-row>
                <b-col cols="12" md="8" class="mx-auto">
                    <div id="body-container">
                        <div class="p-0 pb-5 text-center">
                            <img :src="`${publicPath}/img/gep/withdrawal-icon.svg`"
                                style="background-color: #EDF8F1;border-radius: 20px;">
                            <h5 class="my-3">{{ $t("Withdrawal Same Name") }}</h5>
                            <hr />

                            <div class="d-flex mb-3">
                                <div>{{ $t("Payment Methods") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ dataSummary.paymentMode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Amount") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ dataSummary.paymentCcy }} {{ (dataSummary.fixedModel ==
                                    1) ? getAmount(dataSummary.paymentAmount) : getAmount(dataSummary.payeeAmount) }}
                                </div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Payment Fee") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">USD {{ getAmount(dataSummary.paymentFeeAmount) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Payment Fee Currency") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ dataSummary.paymentFeeCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Company Account Name") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ dataSummary.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Company Currency") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ dataSummary.accountCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Company Card Number") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ dataSummary.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Payment Type") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ getType(dataSummary.fixedModel) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Purpose of Payment") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ getPurpose(dataSummary.paymentPurpose) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Payment Reference") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ dataSummary.paymentReference }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Bank charges to be borne") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">{{ getCostBorne(dataSummary.costBorne) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>{{ $t("Proof of Payment") }}</div>
                                <div class="ml-auto fw-700" v-if="dataSummary">
                                    <a class="link" :href="urlFile">{{ $t("Download Voucher") }}</a>
                                </div>
                            </div>

                            <hr />
                            <div class="d-flex mb-0">
                                <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{
                                    $t('Previous') }}</button>
                                <button @click="$bvModal.show('modal-payment-password');"
                                    class="btn btn-primary d-block">{{ $t('Submit') }}</button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

        </b-container>

        <b-modal id="modal-payment-password" hide-footer hide-title>
            <PaymentPassword @on-submit="validatePin"></PaymentPassword>
        </b-modal>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>

import LoaderComponent from "@/components/LoaderComponent";
import stepContainer from "@/components/CardManagement/stepContainer";
import PaymentPassword from "@/components/PaymentPassword";
import Global from '@/services/Global';
import Companies from "@/services/Companies";
import Common from "@/services/Common";
import CreateAccount from '@/services/CreateAccount';
import Withdrawal from '@/services/Withdrawal';

export default {
    name: 'summary-same-name',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            isLoading: false,
            userNo: '',
            companyList: [],
            dataSummary: null,
            // paymentMaterial: '',
            transferId: '',
            urlFile: '',
            // filetypePaymentMaterial: '',
            // formattedFileName: '',
            fixedModelList: {
                1: "Foreign Exchange Account",
                2: "Receiving Account"
            },
            paymentPurposeOpt: {
                1: "current settlement",
                2: "loan",
                3: "travel expenses",
                4: "living expenses",
                5: "investment funds",
                6: "office expenses",
                7: "engineering funds",
                8: "labor costs/salaries",
                9: "tuition fees",
                10: "others"
            },
            costBorneOpt: {
                "OUR": "OUR (sender pays all charges)",
                "SHA": "SHA (shared charges)"
            },
            paymentChannelTypeOpt: {
                "SWIFT": "SWIFT",
                "LOCAL": "LOCAL"
            },
            stepList: ["Select Withdrawal", "Fill Information", "Withdrawal Summary"],

        }
    },
    components: {
        LoaderComponent,
        stepContainer,
        PaymentPassword
    },
    methods: {
        validatePin(pin) {
            let self = this;
            this.isLoading = true;
            Common.validate_payment_password({
                "securitycode": pin.join(""),
            }).then(response => {
                if (response.status == 200) {
                    this.$bvModal.hide('modal-payment-password');
                    self.doSubmit();
                }
            }).catch(err => {
                self.isLoading = false;
                this.checkError(err);
            });
        },
        getCostBorne(type) {
            return this.costBorneOpt[type];
        },
        getPurpose(type) {
            return this.paymentPurposeOpt[parseInt(type)];
        },
        getAmount(amount) {
            return Global.addCommas(amount);
        },
        getMessage: function (key) {
            return this.$t(key)
        },
        getType(type) {
            return this.fixedModelList[parseInt(type)];
        },
        doSubmit() {
            let self = this;
            const bodyAccountTransfer = {
                userNo: this.userNo, // userNo orang yang login
                payerAmt: this.dataSummary.paymentAmount == 0 ? this.dataSummary.payeeAmount : this.dataSummary.paymentAmount,
                payerCcy: this.dataSummary.paymentCcy,
                payeeUserNo: this.dataSummary.userNoMasterCompany // userNo master company (BurgerKing)
            };

            Companies.accountsTransfer(bodyAccountTransfer).then((response) => {
                if (response.status == 200) {
                    self.isLoading = false;

                    const data = response.data.data;
                    const transferId = data.transferId;

                    console.log("Transfer ID:", transferId);

                    const body = { 'userNo': this.userNo, 'transfer_id': transferId };

                    Withdrawal.adjustSameName(body).then((response) => {
                        if (response.status == 200) {
                            self.isLoading = false;
                            self.$swal({
                                icon: 'success',
                                title: self.getMessage('Success'),
                                showConfirmButton: true,
                            }).then((result) => {
                                self.$router.push({
                                    path: '/withdrawal',
                                });
                            });
                        }
                    })
                        .catch((err) => {
                            console.log(err);
                            self.checkError(err);
                        });
                }

            }).catch((err) => {
                console.log(err);
                self.checkError(err);
            });

        },
        checkError(err) {
            let self = this;
            this.isLoading = false;
            const response = err.response;

            console.log(err);

            if (response.status == 400 || response.status == 500) {
                try {
                    response.data.message = JSON.parse(response.data.message);
                }
                catch (e) {
                    console.log("");
                }

                if (typeof response.data.message === 'string') {
                    this.$swal({
                        icon: 'info',
                        html: response.data.message,
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
                else {
                    if (response.data.message['errorMsg']) {
                        this.$swal({
                            icon: 'info',
                            html: response.data.message['errorMsg'],
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else {
                        let ret = [];
                        Object.keys(response.data.message).forEach((key) => {
                            if (typeof response.data.message === 'string') {
                                ret.push(response.data.message[key][0]);
                            }
                            else {
                                ret.push(response.data.message[key][0]['message']);
                            }
                        });

                        this.$swal({
                            icon: 'info',
                            html: ret.join("<br>"),
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                }
            }
            else if (response.status == 401 && response.data.name == "Unauthorized") {
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                this.$router.push({
                    path: '/login',
                });
            }
            else {
                if (localStorage.getItem("token")) {
                    var msg = (response.data) ? response.data.message : err.message;
                    this.$swal({
                        icon: 'info',
                        html: msg,
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
            }
        },
        getUser() {
            let self = this;
            CreateAccount.list()
                .then((response) => {
                    if (response.status == 200) {
                        let account = response.data.data;
                        if (account) {
                            account.forEach(element => {
                                if (element.status == 2) {
                                    // self.accountId = element.id;
                                    self.userNo = element.userNo;
                                    self.getContact();
                                }
                            });
                        }
                    }
                }).catch(err => {
                    self.checkError(err);
                });
        },
        getContact() {
            let self = this;
            let opt = {
                userNo: this.userNo,
                page: this.currentPage,
                pagesize: -1,
                sort: "-updated_at"
            };

            Companies.partnerList(opt).then((response) => {
                if (response.status == 200) {
                    const data = response.data.data.data;
                    self.companyList = data;
                    self.getDraft();
                }
            }).catch(err => {
                self.checkError(err);
            });
        },
        getDraft() {
            let self = this;
            const params = { userNo: self.userNo };
            Withdrawal.draftSameName(params).then((response) => {
                if (response.status == 200) {
                    const data = response.data.data;

                    if (data) {
                        const company = self.companyList.filter(item => item.bankAccount.id == data.partnerBankId);
                        if (company.length > 0) {
                            data.accountName = company[0].name;
                            data.cardNo = company[0].bankAccount.cardNo;
                            data.payeeCcy = company[0].currency;
                            data.userNoMasterCompany = company[0].userNo;
                        }

                        self.dataSummary = data;

                        // ambil file
                        CreateAccount.getFile({ fileId: data.paymentMaterial }).then(response => {
                            const dataFile = response.data.data[0];
                            if (dataFile.type == 23) {
                                self.urlFile = dataFile.file;
                            }
                        });
                    }
                }

                self.isLoading = false;
            })
                .catch(err => {
                    self.checkError(err);
                });
        },
        // formatFileName() {
        //     const date = new Date();
        //     const formattedDate = `${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
        //     const extension = this.urlFile.split('.').pop();
        //     this.formattedFileName = `voucher_${formattedDate}.${extension}`;
        // },
        // downloadFile() {
        //     let self = this;
        //     self.formatFileName();
        //     fetch(this.urlFile)
        //         .then(response => response.blob())
        //         .then(blob => {
        //             const url = window.URL.createObjectURL(blob);
        //             const a = document.createElement('a');
        //             a.href = url;
        //             a.download = this.formattedFileName;
        //             document.body.appendChild(a);
        //             a.click();
        //             a.remove();
        //             window.URL.revokeObjectURL(url);
        //         })
        //         .catch(error => console.error('Error downloading the file:', error));
        // },
    },
    mounted() {
        let self = this;
        self.$nextTick(() => {
            self.isLoading = true;
            self.getUser();
        });
    }
};
</script>

<style scoped>
a.link {
    color: #6153d7 !important;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
}

ul li {
    list-style: disc;
}

point .number {
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}

.account-type:hover {
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}

.block-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

hr {
    border-style: dashed;
}
</style>